import { gql } from '@apollo/client/core';
import { client } from '@/shared/apollo-api/business/client';
import type { ApolloQueryResult } from '@apollo/client/core/types';
import type { Feedback } from '@/shared/apollo-api/__generated__/types';
import {
  FeedbackSortType,
  FeedbackFilterType,
  Transformation,
} from '@/shared/apollo-api/__generated__/types';

export interface ProductPageFeedbackProps {
  productId: number;
  page?: number;
  size?: number;
  sort?: FeedbackSortType;
  filters?: FeedbackFilterType[];
  trans?: Transformation;
}

export interface FeedbacksResponse {
  productPage: {
    feedbacks: Feedback[];
  };
}

export const productPageFeedback = async ({
  productId,
  page = 0,
  size = 10,
  sort = FeedbackSortType.Relevance,
  filters = [],
  trans = Transformation.Product_720,
}: ProductPageFeedbackProps): Promise<ApolloQueryResult<FeedbacksResponse>> => {
  return await client.query({
    query: gql`
      query Feedbacks(
        $productId: Int!
        $trans: Transformation!
        $filters: [FeedbackFilterType!]
        $page: Int!
        $size: Int!
        $sort: FeedbackSortType!
      ) {
        productPage(id: $productId) {
          feedbacks(filters: $filters, page: $page, size: $size, sort: $sort) {
            anonymous
            cons
            content
            customerName
            dateCreated
            datePublished
            id
            photos {
              key
              link(trans: $trans) {
                high
                low
              }
              original {
                high
                low
              }
            }
            pros
            rating
            reply {
              content
              dateCreated
              id
              shop {
                avatar {
                  high
                  low
                }
                feedbackQuantity
                id
                official
                ordersQuantity
                rating
                seller {
                  accountId
                  legalRecords {
                    name
                    value
                  }
                }
                shortTitle
                title
                url
              }
            }
            sku {
              id
              fullPrice
              characteristicValues {
                characteristic {
                  id
                  title
                  type
                }
                id
                photo {
                  key
                }
                title
                value
              }
              sellPrice
            }
          }
        }
      }
    `,
    variables: {
      productId,
      page,
      size,
      sort,
      filters,
      trans,
    },
  });
};
